export const GET_USER_TRIBUN_TOKEN_REQUEST = 'GET_USER_TRIBUN_TOKEN_REQUEST';
export const GET_USER_TRIBUN_TOKEN_SUCCESS = 'GET_USER_TRIBUN_TOKEN_SUCCESS';
export const GET_USER_TRIBUN_TOKEN_FAILURE = 'GET_USER_TRIBUN_TOKEN_FAILURE';

export const GET_TRIBUN_USER_REQUEST = 'GET_TRIBUN_USER_REQUEST';
export const GET_TRIBUN_USER_SUCCESS = 'GET_TRIBUN_USER_SUCCESS';
export const GET_TRIBUN_USER_FAILURE = 'GET_TRIBUN_USER_FAILURE';

export const SET_TRIBUN_USER_TO_BLOCKED = 'SET_TRIBUN_USER_TO_BLOCKED';

export const GET_NICKNAME_CHANGE_REQUEST = 'GET_NICKNAME_CHANGE_REQUEST';
export const GET_NICKNAME_CHANGE_SUCCESS = 'GET_NICKNAME_CHANGE_SUCCESS';
export const GET_NICKNAME_CHANGE_FAILURE = 'GET_NICKNAME_CHANGE_FAILURE';

export const GET_TRIBUN_NOTIFICATION_COUNT_REQUEST = 'GET_TRIBUN_NOTIFICATION_COUNT_REQUEST';
export const GET_TRIBUN_NOTIFICATION_COUNT_SUCCESS = 'GET_TRIBUN_NOTIFICATION_COUNT_SUCCESS';
export const GET_TRIBUN_NOTIFICATION_COUNT_FAILURE = 'GET_TRIBUN_NOTIFICATION_COUNT_FAILURE';

export const GET_TRIBUN_ANOTHER_USER_REQUEST = 'GET_TRIBUN_ANOTHER_USER_REQUEST';
export const GET_TRIBUN_ANOTHER_USER_SUCCESS = 'GET_TRIBUN_ANOTHER_USER_SUCCESS';
export const GET_TRIBUN_ANOTHER_USER_FAILURE = 'GET_TRIBUN_ANOTHER_USER_FAILURE';

export const GET_TRIBUN_LAST_WIN_LOST_COUPONS_REQUEST = 'GET_TRIBUN_LAST_WIN_LOST_COUPONS_REQUEST';
export const GET_TRIBUN_LAST_WIN_LOST_COUPONS_SUCCESS = 'GET_TRIBUN_LAST_WIN_LOST_COUPONS_SUCCESS';
export const GET_TRIBUN_LAST_WIN_LOST_COUPONS_FAILURE = 'GET_TRIBUN_LAST_WIN_LOST_COUPONS_FAILURE';

export const CREATE_TRIBUN_USER_REQUEST = 'CREATE_TRIBUN_USER_REQUEST';
export const CREATE_TRIBUN_USER_SUCCESS = 'CREATE_TRIBUN_USER_SUCCESS';
export const CREATE_TRIBUN_USER_FAILURE = 'CREATE_TRIBUN_USER_FAILURE';

export const GET_PROFIL_TRIBUN_COUPONS_REQUEST = 'GET_PROFIL_TRIBUN_COUPONS_REQUEST';
export const GET_PROFIL_TRIBUN_COUPONS_SUCCESS = 'GET_PROFIL_TRIBUN_COUPONS_SUCCESS';
export const GET_PROFIL_TRIBUN_COUPONS_FAILURE = 'GET_PROFIL_TRIBUN_COUPONS_FAILURE';
export const GET_PROFIL_TRIBUN_COUPONS_INITIAL_STATE = 'GET_PROFIL_TRIBUN_COUPONS_INITIAL_STATE';

export const GET_TRIBUN_FOLLOWINGS_REQUEST = 'GET_TRIBUN_FOLLOWINGS_REQUEST';
export const GET_TRIBUN_FOLLOWINGS_SUCCESS = 'GET_TRIBUN_FOLLOWINGS_SUCCESS';
export const GET_TRIBUN_FOLLOWINGS_FAILURE = 'GET_TRIBUN_FOLLOWINGS_FAILURE';

export const GET_TRIBUN_FOLLOWERS_REQUEST = 'GET_TRIBUN_FOLLOWERS_REQUEST';
export const GET_TRIBUN_FOLLOWERS_SUCCESS = 'GET_TRIBUN_FOLLOWERS_SUCCESS';
export const GET_TRIBUN_FOLLOWERS_FAILURE = 'GET_TRIBUN_FOLLOWERS_FAILURE';
export const RESET_TRIBUN_PROFILE = 'RESET_TRIBUN_PROFILE';

export const GET_ALL_TRIBUN_COUPONS_REQUEST = 'GET_ALL_TRIBUN_COUPONS_REQUEST';
export const GET_ALL_TRIBUN_COUPONS_SUCCESS = 'GET_ALL_TRIBUN_COUPONS_SUCCESS';
export const GET_ALL_TRIBUN_COUPONS_FAILURE = 'GET_ALL_TRIBUN_COUPONS_FAILURE';
export const GET_MATCH_CARD_TRIBUN_COUPONS_LOADMORE_SUCCESS = 'GET_MATCH_CARD_TRIBUN_COUPONS_LOADMORE_SUCCESS';

export const FOLLOW_TRIBUN_USER_REQUEST = 'FOLLOW_TRIBUN_USER_REQUEST';
export const FOLLOW_TRIBUN_USER_SUCCESS = 'FOLLOW_TRIBUN_USER_SUCCESS';
export const FOLLOW_TRIBUN_USER_FAILURE = 'FOLLOW_TRIBUN_USER_FAILURE';

export const MUTE_TRIBUN_USER_REQUEST = 'MUTE_TRIBUN_USER_REQUEST';
export const MUTE_TRIBUN_USER_SUCCESS = 'MUTE_TRIBUN_USER_SUCCESS';
export const MUTE_TRIBUN_USER_FAILURE = 'MUTE_TRIBUN_USER_FAILURE';

export const UNFOLLOW_WATCHING_TRIBUN_USER_REQUEST = 'UNFOLLOW_WATCHING_TRIBUN_USER_REQUEST';
export const UNFOLLOW_WATCHING_TRIBUN_USER_SUCCESS = 'UNFOLLOW_WATCHING_TRIBUN_USER_SUCCESS';
export const UNFOLLOW_WATCHING_TRIBUN_USER_FAILURE = 'UNFOLLOW_WATCHING_TRIBUN_USER_FAILURE';

export const LIKE_OR_UNLIKE_COUPON_REQUEST = 'LIKE_OR_UNLIKE_COUPON_REQUEST';
export const LIKE_OR_UNLIKE_COUPON_SUCCESS = 'LIKE_OR_UNLIKE_COUPON_SUCCESS';
export const LIKE_OR_UNLIKE_COUPON_FAILURE = 'LIKE_OR_UNLIKE_COUPON_FAILURE';

export const LIKE_OR_UNLIKE_COMMENT_REQUEST = 'LIKE_OR_UNLIKE_COMMENT_REQUEST';
export const LIKE_OR_UNLIKE_COMMENT_SUCCESS = 'LIKE_OR_UNLIKE_COMMENT_SUCCESS';
export const LIKE_OR_UNLIKE_COMMENT_FAILURE = 'LIKE_OR_UNLIKE_COMMENT_FAILURE';

export const UPDATE_TRIBUN_NICKNAME_REQUEST = 'UPDATE_TRIBUN_NICKNAME_REQUEST';
export const UPDATE_TRIBUN_NICKNAME_SUCCESS = 'UPDATE_TRIBUN_NICKNAME_SUCCESS';
export const UPDATE_TRIBUN_NICKNAME_FAILURE = 'UPDATE_TRIBUN_NICKNAME_FAILURE';

export const UPDATE_TRIBUN_COUPON_NAME_REQUEST = 'UPDATE_TRIBUN_COUPON_NAME_REQUEST';
export const UPDATE_TRIBUN_COUPON_NAME_SUCCESS = 'UPDATE_TRIBUN_COUPON_NAME_SUCCESS';
export const UPDATE_TRIBUN_COUPON_NAME_FAILURE = 'UPDATE_TRIBUN_COUPON_NAME_FAILURE';

export const DELETE_TRIBUN_COUPON_NAME_REQUEST = 'DELETE_TRIBUN_COUPON_NAME_REQUEST';
export const DELETE_TRIBUN_COUPON_NAME_SUCCESS = 'DELETE_TRIBUN_COUPON_NAME_SUCCESS';
export const DELETE_TRIBUN_COUPON_NAME_FAILURE = 'DELETE_TRIBUN_COUPON_NAME_FAILURE';

export const SHOW_OR_HIDE_CHECKBOX_TRIBUN_COUPONS_REQUEST = 'SHOW_OR_HIDE_CHECKBOX_TRIBUN_COUPONS_REQUEST';
export const SHOW_OR_HIDE_CHECKBOX_TRIBUN_COUPONS_SUCCESS = 'SHOW_OR_HIDE_CHECKBOX_TRIBUN_COUPONS_SUCCESS';
export const SHOW_OR_HIDE_CHECKBOX_TRIBUN_COUPONS_FAILURE = 'SHOW_OR_HIDE_CHECKBOX_TRIBUN_COUPONS_FAILURE';

export const HIDE_TRIBUN_FEED_COUPON_REQUEST = 'HIDE_TRIBUN_FEED_COUPON_REQUEST';
export const HIDE_TRIBUN_FEED_COUPON_SUCCESS = 'HIDE_TRIBUN_FEED_COUPON_SUCCESS';
export const HIDE_TRIBUN_FEED_COUPON_FAILURE = 'HIDE_TRIBUN_FEED_COUPON_FAILURE';

export const GET_TRIBUN_NOTIFICATIONS_REQUEST = 'GET_TRIBUN_NOTIFICATIONS_REQUEST';
export const GET_TRIBUN_NOTIFICATIONS_SUCCESS = 'GET_TRIBUN_NOTIFICATIONS_SUCCESS';
export const GET_TRIBUN_NOTIFICATIONS_FAILURE = 'GET_TRIBUN_NOTIFICATIONS_FAILURE';
export const GET_TRIBUN_NOTIFICATIONS_INITIAL_STATE = 'GET_TRIBUN_NOTIFICATIONS_INITIAL_STATE';

export const GET_TRIBUN_COUPON_DETAILS_REQUEST = 'GET_TRIBUN_COUPON_DETAILS_REQUEST';
export const GET_TRIBUN_COUPON_DETAILS_SUCCESS = 'GET_TRIBUN_COUPON_DETAILS_SUCCESS';
export const GET_TRIBUN_COUPON_DETAILS_FAILURE = 'GET_TRIBUN_COUPON_DETAILS_FAILURE';
export const RESET_TRIBUN_COUPON_DETAILS = 'RESET_TRIBUN_COUPON_DETAILS';
export const SAVE_UNEVALUATED_EVENTS = 'SAVE_UNEVALUATED_EVENTS';
export const RESET_UNEVALUATED_EVENTS = 'RESET_UNEVALUATED_EVENTS';

export const GET_POPULAR_TRIBUN_USERS_REQUEST = 'GET_POPULAR_TRIBUN_USERS_REQUEST';
export const GET_POPULAR_TRIBUN_USERS_SUCCESS = 'GET_POPULAR_TRIBUN_USERS_SUCCESS';
export const GET_POPULAR_TRIBUN_USERS_FAILURE = 'GET_POPULAR_TRIBUN_USERS_FAILURE';

export const GET_FOLLOWING_TRIBUN_USERS_REQUEST = 'GET_FOLLOWING_TRIBUN_USERS_REQUEST';
export const GET_FOLLOWING_TRIBUN_USERS_SUCCESS = 'GET_FOLLOWING_TRIBUN_USERS_SUCCESS';
export const GET_FOLLOWING_TRIBUN_USERS_FAILURE = 'GET_FOLLOWING_TRIBUN_USERS_FAILURE';

export const GET_WINNER_TRIBUN_USERS_REQUEST = 'GET_WINNER_TRIBUN_USERS_REQUEST';
export const GET_WINNER_TRIBUN_USERS_SUCCESS = 'GET_WINNER_TRIBUN_USERS_SUCCESS';
export const GET_WINNER_TRIBUN_USERS_FAILURE = 'GET_WINNER_TRIBUN_USERS_FAILURE';

export const SHARE_TRIBUN_COUPON_REQUEST = 'SHARE_TRIBUN_COUPON_REQUEST';
export const SHARE_TRIBUN_COUPON_SUCCESS = 'SHARE_TRIBUN_COUPON_SUCCESS';
export const SHARE_TRIBUN_COUPON_FAILURE = 'SHARE_TRIBUN_COUPON_FAILURE';

export const GET_TRIBUN_COUPONS_REQUEST = 'GET_TRIBUN_COUPONS_REQUEST';
export const GET_TRIBUN_COUPONS_SUCCESS = 'GET_TRIBUN_COUPONS_SUCCESS';
export const GET_TRIBUN_COUPONS_FAILURE = 'GET_TRIBUN_COUPONS_FAILURE';
export const RESET_TRIBUN_COUPONS_PAGINATION = 'RESET_TRIBUN_COUPONS_PAGINATION';

export const POST_TRIBUN_SEARCH_REQUEST = 'POST_TRIBUN_SEARCH_REQUEST';
export const POST_TRIBUN_SEARCH_SUCCESS = 'POST_TRIBUN_SEARCH_SUCCESS';
export const POST_TRIBUN_SEARCH_FAILURE = 'POST_TRIBUN_SEARCH_FAILURE';

export const POST_TRIBUN_MENTION_SEARCH_REQUEST = 'POST_TRIBUN_MENTION_SEARCH_REQUEST';
export const POST_TRIBUN_MENTION_SEARCH_SUCCESS = 'POST_TRIBUN_MENTION_SEARCH_SUCCESS';
export const POST_TRIBUN_MENTION_SEARCH_FAILURE = 'POST_TRIBUN_MENTION_SEARCH_FAILURE';

export const SHOW_OR_HIDE_COUOPON_REQUEST = 'SHOW_OR_HIDE_COUOPON_REQUEST';
export const SHOW_OR_HIDE_COUOPON_SUCCESS = 'SHOW_OR_HIDE_COUOPON_SUCCESS';
export const SHOW_OR_HIDE_COUOPON_FAILURE = 'SHOW_OR_HIDE_COUOPON_FAILURE';

export const VERIFY_TRIBUN_REQUEST = 'VERIFY_TRIBUN_REQUEST';
export const VERIFY_TRIBUN_SUCCESS = 'VERIFY_TRIBUN_SUCCESS';
export const VERIFY_TRIBUN_FAILURE = 'VERIFY_TRIBUN_FAILURE';

export const GET_SEARCHED_EVENT_COUPON_REQUEST = 'GET_SEARCHED_EVENT_COUPON_REQUEST';
export const GET_SEARCHED_EVENT_COUPON_SUCCESS = 'GET_SEARCHED_EVENT_COUPON_SUCCESS';
export const GET_SEARCHED_EVENT_COUPON_FAILURE = 'GET_SEARCHED_EVENT_COUPON_FAILURE';

export const SEARCH_PREDICTIONS_REQUEST = 'SEARCH_PREDICTIONS_REQUEST';
export const SEARCH_PREDICTIONS_SUCCESS = 'SEARCH_PREDICTIONS_SUCCESS';
export const SEARCH_PREDICTIONS_FAILURE = 'SEARCH_PREDICTIONS_FAILURE';

export const COMPLAINT_TRIBUN_REQUEST = 'COMPLAINT_TRIBUN_REQUEST';
export const COMPLAINT_TRIBUN_SUCCESS = 'COMPLAINT_TRIBUN_SUCCESS';
export const COMPLAINT_TRIBUN_FAILURE = 'COMPLAINT_TRIBUN_FAILURE';

export const SEND_COMMENT_REQUEST = 'SEND_COMMENT_REQUEST';
export const SEND_COMMENT_SUCCESS = 'SEND_COMMENT_SUCCESS';
export const SEND_COMMENT_FAILURE = 'SEND_COMMENT_FAILURE';
export const SEND_COMMENT_LIMIT_FAILURE = 'SEND_COMMENT_LIMIT_FAILURE';

export const GET_COMMENT_REQUEST = 'GET_COMMENT_REQUEST';
export const GET_COMMENT_SUCCESS = 'GET_COMMENT_SUCCESS';
export const GET_COMMENT_FAILURE = 'GET_COMMENT_FAILURE';
export const GET_COMMENT_LIST_SUCCESS = 'GET_COMMENT_LIST_SUCCESS';
export const RESET_COMMENT_LIST = 'RESET_COMMENT_LIST';
export const SPACE_COUPON_MIX_PANEL = 'SPACE_COUPON_MIX_PANEL';

export const DELETE_COMMENT_REQUEST = 'DELETE_COMMENT_REQUEST';
export const DELETE_COMMENT_SUCCESS = 'DELETE_COMMENT_SUCCESS';
export const DELETE_COMMENT_FAILURE = 'DELETE_COMMENT_FAILURE';

export const BLOCK_USER_REQUEST = 'BLOCK_USER_REQUEST';
export const BLOCK_USER_SUCCESS = 'BLOCK_USER_SUCCESS';
export const BLOCK_USER_FAILURE = 'BLOCK_USER_FAILURE';

export const UNBLOCK_USER_REQUEST = 'UNBLOCK_USER_REQUEST';
export const UNBLOCK_USER_SUCCESS = 'UNBLOCK_USER_SUCCESS';
export const UNBLOCK_USER_FAILURE = 'UNBLOCK_USER_FAILURE';

export const BLOCK_ANOTHER_USER_REQUEST = 'BLOCK_ANOTHER_USER_REQUEST';
export const BLOCK_ANOTHER_USER_SUCCESS = 'BLOCK_ANOTHER_USER_SUCCESS';
export const BLOCK_ANOTHER_USER_FAILURE = 'BLOCK_ANOTHER_USER_FAILURE';

export const UNBLOCK_ANOTHER_USER_REQUEST = 'UNBLOCK_ANOTHER_USER_REQUEST';
export const UNBLOCK_ANOTHER_USER_SUCCESS = 'UNBLOCK_ANOTHER_USER_SUCCESS';
export const UNBLOCK_ANOTHER_USER_FAILURE = 'UNBLOCK_ANOTHER_USER_FAILURE';


export const SWITCH_TRIBUN_TAB = 'SWITCH_TRIBUN_TAB';

export const RESET_TRIBUN_TAB = 'RESET_TRIBUN_TAB';
export const RESET_SEARCH_AREA = 'RESET_SEARCH_AREA';
export const RESET_SEARCH_MATCH = 'RESET_SEARCH_MATCH';

export const UPDATE_TRIBUN_COMMIT_PERMISSION_REQUEST = 'UPDATE_TRIBUN_COMMIT_PERMISSION_REQUEST';
export const UPDATE_TRIBUN_COMMIT_PERMISSION_SUCCESS = 'UPDATE_TRIBUN_COMMIT_PERMISSION_SUCCESS';
export const UPDATE_TRIBUN_COMMIT_PERMISSION_FAILURE = 'UPDATE_TRIBUN_COMMIT_PERMISSION_FAILURE';

export const UPDATE_AUTO_SPACE_COUPON_SHARE_REQUEST = 'UPDATE_AUTO_SPACE_COUPON_SHARE_REQUEST';
export const UPDATE_AUTO_SPACE_COUPON_SHARE_SUCCESS = 'UPDATE_AUTO_SPACE_COUPON_SHARE_SUCCESS';
export const UPDATE_AUTO_SPACE_COUPON_SHARE_FAILURE = 'UPDATE_AUTO_SPACE_COUPON_SHARE_FAILURE';

export const COMMENT_FORBID_ALLOW_REQUEST = 'COMMENT_FORBID_ALLOW_REQUEST';
export const COMMENT_FORBID_ALLOW_SUCCESS = 'COMMENT_FORBID_ALLOW_SUCCESS';
export const COMMENT_FORBID_ALLOW_FAILURE = 'COMMENT_FORBID_ALLOW_FAILURE';

export const POST_TRIBUN_AVATAR_REQUEST = 'POST_TRIBUN_AVATAR_REQUEST';
export const POST_TRIBUN_AVATAR_SUCCESS = 'POST_TRIBUN_AVATAR_SUCCESS';
export const POST_TRIBUN_AVATAR_FAILURE = 'POST_TRIBUN_AVATAR_FAILURE';

export const DELETE_TRIBUN_AVATAR_REQUEST = 'DELETE_TRIBUN_AVATAR_REQUEST';
export const DELETE_TRIBUN_AVATAR_SUCCESS = 'DELETE_TRIBUN_AVATAR_SUCCESS';
export const DELETE_TRIBUN_AVATAR_FAILURE = 'DELETE_TRIBUN_AVATAR_FAILURE';

export const GET_LEADERBOARD_SCORES_REQUEST = 'GET_LEADERBOARD_SCORES_REQUEST';
export const GET_LEADERBOARD_SCORES_SUCCESS = 'GET_LEADERBOARD_SCORES_SUCCESS';
export const GET_LEADERBOARD_SCORES_FAILURE = 'GET_LEADERBOARD_SCORES_FAILURE';

export const GET_LEADERBOARD_SCORES_LIST_REQUEST = 'GET_LEADERBOARD_SCORES_LIST_REQUEST';
export const GET_LEADERBOARD_SCORES_LIST_SUCCESS = 'GET_LEADERBOARD_SCORES_LIST_SUCCESS';
export const GET_LEADERBOARD_SCORES_LIST_FAILURE = 'GET_LEADERBOARD_SCORES_LIST_FAILURE';

export const GET_MINI_LEADERBOARD_SCORE_LIST_REQUEST = 'GET_MINI_LEADERBOARD_SCORE_LIST_REQUEST';
export const GET_MINI_LEADERBOARD_SCORE_LIST_SUCCESS = 'GET_MINI_LEADERBOARD_SCORE_LIST_SUCCESS';
export const GET_MINI_LEADERBOARD_SCORE_LIST_FAILURE = 'GET_MINI_LEADERBOARD_SCORE_LIST_FAILURE';

export const GET_LEADERBOARD_RESET_SORTING = 'GET_LEADERBOARD_RESET_SORTING';
export const RESET_TRIBUN_SCORES = 'RESET_TRIBUN_SCORES';

export const PROFILE = 'profile';

export const GET_LEADER_TRIBUN_USERS_REQUEST = 'GET_LEADER_TRIBUN_USERS_REQUEST';
export const GET_LEADER_TRIBUN_USERS_SUCCESS = 'GET_LEADER_TRIBUN_USERS_SUCCESS';
export const GET_LEADER_TRIBUN_USERS_FAILURE = 'GET_LEADER_TRIBUN_USERS_FAILURE';

export const SET_PIN_FEED_REQUEST = 'SET_PIN_FEED_REQUEST';
export const SET_PIN_FEED_SUCCESS = 'SET_PIN_FEED_SUCCESS';
export const SET_PIN_FEED_FAILURE = 'SET_PIN_FEED_FAILURE';

export const REMOVE_PIN_FEED_REQUEST = 'REMOVE_PIN_FEED_REQUEST';
export const REMOVE_PIN_FEED_SUCCESS = 'REMOVE_PIN_FEED_SUCCESS';
export const REMOVE_PIN_FEED_FAILURE = 'REMOVE_PIN_FEED_FAILURE';

export const GET_PINNED_FEED_REQUEST = 'GET_PINNED_FEED_REQUEST';
export const GET_PINNED_FEED_SUCCESS = 'GET_PINNED_FEED_SUCCESS';
export const GET_PINNED_FEED_FAILURE = 'GET_PINNED_FEED_FAILURE';

export const GET_TRIBUN_NOTIFICATION_REQUEST = 'GET_TRIBUN_NOTIFICATION_REQUEST';
export const GET_TRIBUN_NOTIFICATION_SUCCESS = 'GET_TRIBUN_NOTIFICATION_SUCCESS';
export const GET_TRIBUN_NOTIFICATION_FAILURE = 'GET_TRIBUN_NOTIFICATION_FAILURE';

export const GET_TRIBUN_BLOCKED_USERS_REQUEST = 'GET_TRIBUN_BLOCKED_USERS_REQUEST';
export const GET_TRIBUN_BLOCKED_USERS_SUCCESS = 'GET_TRIBUN_BLOCKED_USERS_SUCCESS';
export const GET_TRIBUN_BLOCKED_USERS_FAILURE = 'GET_TRIBUN_BLOCKED_USERS_FAILURE';

export const  GET_TRIBUN_PUSH_FOLLOWING_USERS_REQUEST = 'GET_TRIBUN_PUSH_FOLLOWING_USERS_REQUEST';
export const  GET_TRIBUN_PUSH_FOLLOWING_USERS_SUCCESS = 'GET_TRIBUN_PUSH_FOLLOWING_USERS_SUCCESS';
export const  GET_TRIBUN_PUSH_FOLLOWING_USERS_FAILURE = 'GET_TRIBUN_PUSH_FOLLOWING_USERS_SUCCESS';

export const EDIT_TRIBUN_NOTIFICATION_REQUEST = 'EDIT_TRIBUN_NOTIFICATION_REQUEST';
export const EDIT_TRIBUN_NOTIFICATION_SUCCESS = 'EDIT_TRIBUN_NOTIFICATION_SUCCESS';
export const EDIT_TRIBUN_NOTIFICATION_FAILURE = 'EDIT_TRIBUN_NOTIFICATION_FAILURE';

export const GET_PUSH_FOLLOW_REQUEST = 'GET_PUSH_FOLLOW_REQUEST';
export const GET_PUSH_FOLLOW_SUCCESS =  'GET_PUSH_FOLLOW_SUCCESS';
export const GET_PUSH_FOLLOW_FAILURE = 'GET_PUSH_FOLLOW_FAILURE';

export const GET_PUSH_UNFOLLOW_REQUEST = 'GET_PUSH_UNFOLLOW_REQUEST';
export const GET_PUSH_UNFOLLOW_SUCCESS = 'GET_PUSH_UNFOLLOW_SUCCESS';
export const GET_PUSH_UNFOLLOW_FAILURE = 'GET_PUSH_UNFOLLOW_FAILURE';

export const GET_USER_PUSH_COUNT_REQUEST = 'GET_USER_PUSH_COUNT_REQUEST';
export const GET_USER_PUSH_COUNT_SUCCESS = 'GET_USER_PUSH_COUNT_SUCCESS';
export const GET_USER_PUSH_COUNT_FAILURE = 'GET_USER_PUSH_COUNT_FAILURE';

export const GET_USER_TRIBUN_BLOCK_REQUEST = 'GET_USER_TRIBUN_BLOCK_REQUEST';
export const GET_USER_TRIBUN_BLOCK_SUCCESS = 'GET_USER_TRIBUN_BLOCK_SUCCESS';
export const GET_USER_TRIBUN_BLOCK_FAILURE = 'GET_USER_TRIBUN_BLOCK_FAILURE';

export const GET_USER_TRIBUN_UNBLOCK_REQUEST = 'GET_USER_TRIBUN_UNBLOCK_REQUEST';
export const GET_USER_TRIBUN_UNBLOCK_SUCCESS = 'GET_USER_TRIBUN_UNBLOCK_SUCCESS';
export const GET_USER_TRIBUN_UNBLOCK_FAILURE = 'GET_USER_TRIBUN_UNBLOCK_FAILURE';

export const GET_BLOCK_USER_COUNT_REQUEST = 'GET_BLOCK_USER_COUNT_REQUEST';
export const  GET_BLOCK_USER_COUNT_SUCCESS = 'GET_BLOCK_USER_COUNT_SUCCESS';
export const  GET_BLOCK_USER_COUNT_FAILURE = 'GET_BLOCK_USER_COUNT_FAILURE';

export const GET_MUTED_USER_COUNT_REQUEST = 'GET_MUTED_USER_COUNT_REQUEST';
export const GET_MUTED_USER_COUNT_SUCCESS = 'GET_MUTED_USER_COUNT_SUCCESS';
export const GET_MUTED_USER_COUNT_FAILURE = 'GET_MUTED_USER_COUNT_FAILURE';

export const GET_TRIBUN_PUSH_FOLLOWING_USERS_RESET = 'GET_TRIBUN_PUSH_FOLLOWING_USERS_RESET';

export const GET_TRIBUN_BLOCKED_USERS_RESET = 'GET_TRIBUN_BLOCKED_USERS_RESET';

export const GET_TRIBUN_MUTED_USERS_REQUEST = 'GET_TRIBUN_MUTED_USERS_REQUEST';
export const GET_TRIBUN_MUTED_USERS_SUCCESS = 'GET_TRIBUN_MUTED_USERS_SUCCESS';
export const GET_TRIBUN_MUTED_USERS_FAILURE = 'GET_TRIBUN_MUTED_USERS_FAILURE';
export const GET_TRIBUN_MUTED_USERS_RESET = 'GET_TRIBUN_MUTED_USERS_RESET';

export const GET_TRIBUN_SPACE_COUPONS_REQUEST = 'GET_TRIBUN_SPACE_COUPONS_REQUEST';
export const GET_TRIBUN_SPACE_COUPONS_SUCCESS = 'GET_TRIBUN_SPACE_COUPONS_SUCCESS';
export const GET_TRIBUN_SPACE_COUPONS_FAILURE = 'GET_TRIBUN_SPACE_COUPONS_FAILURE';
export const SET_ACTIVE_SEGMENT = 'SET_ACTIVE_SEGMENT';


export const TRIBUN_ORIGINS = {
  HOME: 'home',
  TRIBUN: 'tribun',
  KICKOFF: 'kickOff',
};

export const TRIBUN_FILTER_SORT_OPTIONS = {
  SORT: {
    type: 'sort',
    localStorageKey: 'tribunHeaderSortOptions',
  },
  FILTER_V2: {
    type: 'filterV2',
    appliedFiltersLocalStorageKey: 'appliedTribunHeaderFilterOptionsV2',
    filterKeyMap: {
      BET_TYPE: {
        isToggle: false,
        isMultiSelect: false,
        isRange: false,
        inputKeys: ['coupon'],
      },
      COUPON_COST: {
        isToggle: true,
        isMultiSelect: false,
        isRange: true,
        inputKeys: ['minCouponCost', 'maxCouponCost'],
        rangeValidationErrorMessageCMSKey: 'tribün_filter_coupon_amount_value_error',
      },
      LEAGUE: {
        isToggle: true,
        isMultiSelect: true,
        isRange: false,
        inputKeys: ['leaguesIds'],
        multiSelectCleanButtonLabelCMSKey: 'tribun_league_filter_cleaner_button_name',
      },
      MATCH_COUNT: {
        isToggle: true,
        isMultiSelect: false,
        isRange: false,
        inputKeys: ['matchCount'],
      },
      TOTAL_ODD: {
        isToggle: true,
        isMultiSelect: false,
        isRange: true,
        inputKeys: ['minTotalOdd', 'maxTotalOdd'],
        rangeValidationErrorMessageCMSKey: 'tribün_filter_total_odd_value_error',
      },
      SPORTS: {
        isToggle: false,
        isMultiSelect: false,
        isRange: false,
        inputKeys: ['sportType'],
      },
    },
    defaultSelectedFilters: {
      coupon: 'all',
      sportType: '0',
    }
  }
};

export const TRIBUN_TAB_TYPE = {
  WON: 'won',
  SEARCH: 'search',
  MATCH_CARD: 'match-card',
  COUPON_DETAIL: 'coupon-detail',
  PROFILE: 'profile',
  FOLLOWING: 'following',
  LEADERBOARD: 'leaderboard',
  LEADER: 'leader',
  POPULAR: 'popular',
  ALL: 'all',
  SPACE_COUPON: 'space-coupon'
};

